import { Button, Group, Modal, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

type Props = {
  readonly opened: boolean
  readonly onClose: () => void
  readonly onConfirm: () => void
  readonly isLoading: boolean
}

export const SyncToProductsConfirmationModal = ({
  opened,
  onClose,
  onConfirm,
  isLoading,
}: Props) => {
  const { t } = useTranslation("admin")

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("customFields.syncToProducts.warning")}
    >
      <Stack>
        <Text>{t("customFields.syncToProducts.confirmation")}</Text>
        <Group grow>
          <Button fullWidth onClick={onClose} variant="secondary">
            {t("customFields.syncToProducts.cancel")}
          </Button>
          <Button
            fullWidth
            onClick={onConfirm}
            variant="primary"
            loading={isLoading}
          >
            {t("customFields.syncToProducts.confirm")}
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
